UAUserSchoolDomainCtrl.$inject = [
  'users',
  'schoolUuids',
  'subgroupUuids',
  'domainUuid',
  'graph',
  'adminApi',
  'adminEntitiesApi',
  'op',
  '$uibModalInstance'
]

export default function UAUserSchoolDomainCtrl(
  users,
  schoolUuids,
  subgroupUuids,
  domainUuid,
  graph,
  adminApi,
  adminEntitiesApi,
  op,
  $modalInstance
) {
  let vm = this;
  this.users = users
  this.domainUuid = domainUuid
  this.schoolUuids = schoolUuids
  this.subgroupUuids = Array.isArray(subgroupUuids) ? subgroupUuids.slice() : []
  this.showError = false
  this.errorMessage = ''
  this.loading = false
  this.importCommitResult = null
  this.successfulUpdateCount = null
  this.failedUpdateCount = null
  this.removeInfo = null
  this.schools = []
  this.subgroups = []
  this.op = op
  this.options = {
    allowMultipleSchools: false
  }

  if (op.toLowerCase().indexOf('school') > -1) {
    this.fetchingSchools = true
    graph.getDomainSchools(domainUuid).then(
      function(schools) {
        this.schools = schools
        this.fetchingSchools = false
      }.bind(this)
    )
  }

  if (this.users.length === 1) {
    this.subgroupUuids = Array.isArray(this.users[0].subgroup_uuids)
      ? this.users[0].subgroup_uuids.slice()
      : []
  }

  this.refreshSubgroups = function() {
    this.fetchingSubgroups = true
    adminEntitiesApi.listSubgroups({ domain_uuid: this.domainUuid }).then(
      function(response) {
        this.subgroups = response.data
        this.fetchingSubgroups = false
      }.bind(this),
      function(err) {
        this.fetchingSubgroups = false
        this.showError = true
        this.errorMessage = (err?.data && (err.data.message || err.data.errors)) || err.message || err
      }.bind(this)
    )
  }.bind(this)

  if (op.toLowerCase().indexOf('subgroup') > -1) {
    this.refreshSubgroups()
  }

  if (domainUuid) {
    graph.getDomain(domainUuid).then(
      function(domain) {
        this.domain = domain
      }.bind(this)
    )
  }

  this.selectDomain = function(domain) {
    this.domainUuid = domain.uuid
  }

  this.multipleSchoolsSelectedButMultipleSchoolsNotAllowed = function() {
    return !this.options.allowMultipleSchools && this.schoolUuids.length > 1
  }

  vm.toggleSubgroup = function(uuid) {
    const index = vm.subgroupUuids.indexOf(uuid)
    if (index > -1) {
      vm.subgroupUuids.splice(index, 1)
    } else {
      vm.subgroupUuids.push(uuid)
    }
  }

  this.continueAction = function() {
    this.loading = true
    this.showError = false

    const userUuids = this.users.map(function(u) {
      return u.uuid
    })
    if (op === 'Add Users to Domain') {
      adminApi
        .addUsersToDomain(userUuids, this.domainUuid)
        .then(actionCallback, actionCallbackError)
    } else if (op === 'Add Users to School') {
      adminApi
        .addUsersToSchools(userUuids, this.schoolUuids, this.domainUuid, {
          allowMultipleSchools: this.options.allowMultipleSchools
        })
        .then(actionCallback, actionCallbackError)
    } else if (op === 'Remove Users from Domain') {
      adminApi
        .removeUsersFromDomain(userUuids, this.domainUuid)
        .then(actionCallback, actionCallbackError)
    } else if (op === 'Remove Users from School') {
      adminApi
        .removeUsersFromSchools(userUuids, this.schoolUuids, this.domainUuid)
        .then(actionCallback, actionCallbackError)
    } else if (op === 'Add Users to Subgroups') {
      if (this.subgroupUuids.length === 0) {
        this.showError = true
        this.loading = false
        this.errorMessage = 'Please select at least one subgroup'
        return
      }
      adminEntitiesApi.addUsersToSubgroups(userUuids, this.subgroupUuids, this.domainUuid).then(actionCallback, actionCallbackError)
    } else if (op === 'Remove Users from Subgroups') {
      if (this.subgroupUuids.length === 0) {
        this.showError = true
        this.loading = false
        this.errorMessage = 'Please select at least one subgroup'
        return
      }
      adminEntitiesApi.removeUsersFromSubgroups(userUuids, this.subgroupUuids, this.domainUuid).then(actionCallback, actionCallbackError)
    }
  }

  const actionCallback = function(response) {
    if (response.data) {
      this.successfulUpdateCount = response.data.transactions.filter(t => t.status === 'successful').length
      this.failedUpdateCount = response.data.transactions.filter(t => t.status !== 'successful').length
    } else if (response.transactions) {
      this.importCommitResult = response
    } else {
      this.removeInfo = response
      if (this.removeInfo?.status === 'ok') {
        vm.subgroupUuids = []
        $modalInstance.close(this.removeInfo)
      } else {
        this.showError = true
        this.errorMessage = this.removeInfo?.errors
      }
    }
    this.loading = false
  }.bind(this)

  const actionCallbackError = function(response) {
    this.loading = false
    this.showError = true
    this.errorMessage = response.message || response.errors || response
  }.bind(this)
}
